import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const UserWorkspaceTable = (props) => {
	const {
		disabled,
		workspaces,
		workspaceOptions,
		onWorkspaceUpdate,
		onRoleUpdate,
		onWorkspaceDelete,
		roleOptions
	} = props;
	return (
		<Table size="small">
			<TableHead>
				<TableRow>
					<TableCell padding="none" style={{ width: '42%' }}>
						<FormattedMessage id="Admin.User.workspace" defaultMessage="Workspace" />
					</TableCell>
					<TableCell style={{ width: '42%' }}>
						<FormattedMessage id="Admin.User.role" defaultMessage="Role" />
					</TableCell>
					<TableCell padding="none" style={{ width: '16%' }} />
				</TableRow>
			</TableHead>
			<TableBody>
				{workspaces.map((scope, index) => (
					<TableRow key={index} style={{ height: '45px'}}>
						<TableCell padding="none" size="small">
							<Select
								id={`workspaces-workspace-${index}`}
								disabled={disabled}
								value={scope.id}
								fullWidth
								onChange={(event) => onWorkspaceUpdate({ index, id: event.target.value })}
							>
								{[...workspaceOptions, scope]
									.sort((a, b) => (a.name < b.name ? -1 : 1))
									.map((value) => (
										<MenuItem key={value.id} value={value.id}>
											{value.name}
										</MenuItem>
									))}
							</Select>
						</TableCell>
						<TableCell size="small">
							<Select
								id={`workspaces-role-${index}`}
								disabled={disabled}
								value={scope.role}
								fullWidth
								onChange={(event) => onRoleUpdate({ index, role: event.target.value })}
							>
								{roleOptions.map((value) => (
									<MenuItem key={value.id} value={value.id}>
										{value.name}
									</MenuItem>
								))}
							</Select>
						</TableCell>
						<TableCell padding="none" size="small">
							<IconButton
								style={{ color: '#FF0022', float: 'right' }}
								onClick={(event) => {
									event.stopPropagation();
									onWorkspaceDelete(index);
								}}
							>
								<DeleteIcon />
							</IconButton>
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	);
};



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/user/UserWorkspaceTable.js